import React from 'react';
import './ReferralTopBarPromo.css';

/**
 * Top-bar referral promo CTA (with dismiss X).
 * Desktop: sits inline with the topbar pills.
 * Mobile: becomes a full-width row below points + coins (via CSS order rules).
 */
const ReferralTopBarPromo = ({ onInviteClick, onDismiss }) => {
  return (
    <div className="topbar-referral-promo" role="group" aria-label="Invite friends promo">
      <button className="topbar-referral-promo-main" onClick={onInviteClick}>
        <span className="topbar-referral-emoji" role="img" aria-hidden="true">🎁</span>
        <span className="topbar-referral-text">
          <strong>Invite</strong>
          <span className="topbar-referral-subtext"> Earn 500 &bull; Friends get bonus 150</span>
        </span>
      </button>
      <button
        className="topbar-referral-promo-dismiss"
        onClick={onDismiss}
        aria-label="Dismiss invite promo"
      >
        &times;
      </button>
    </div>
  );
};

export default ReferralTopBarPromo;


